"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertEventInfo = exports.MAX_CHANGE_VALUE = void 0;
const AlertRuleObjectState_1 = require("spanalog/lib/enums/AlertRuleObjectState");
const AlertRuleTriggerType_1 = require("spanalog/lib/enums/AlertRuleTriggerType");
const AlertRuleTriggerValueType_1 = require("spanalog/lib/enums/AlertRuleTriggerValueType");
// In the database, the change value column is defined as int(10), so this is the largest 10-digit integer value we can
// store there. We'll use this value to represent Infinity when the percent change is infinite.
exports.MAX_CHANGE_VALUE = 999999999;
/**
 * See AlertEventModel for a description of the properties.
 */
class AlertEventInfo {
    /**
     * Returns the creatable DAO properties for a set of creatable AlertEventInfo (DTO) properties.
     *
     * @returns the creatable DAO properties
     */
    static getDaoCreateProps(dtoProps) {
        return {
            org_id: dtoProps.orgId,
            batch_id: dtoProps.batchId,
            old_count: dtoProps.oldCount,
            new_count: dtoProps.newCount,
            record_type: dtoProps.recordType,
            object_type: dtoProps.objectType,
            object_state: dtoProps.objectState,
            trigger_type: dtoProps.triggerType,
            trigger_value_type: dtoProps.triggerValueType,
            rule_trigger_value: dtoProps.ruleTriggerValue,
            // If the old value was 0 we could have an infinite percent change. Since we can't store Infinity in the db, we'll
            // store MAX_CHANGE_VALUE
            event_trigger_value: dtoProps.eventTriggerValue === Infinity ? exports.MAX_CHANGE_VALUE : dtoProps.eventTriggerValue
        };
    }
    /**
     * Returns a text description of an event.
     *
     * @returns the description.
     */
    static getDescription(event) {
        // The number of {objectState} {objectType} records {triggerType} by {eventTriggerValue}{percent}, from {oldCount} to {newCount}
        let desc = 'The number of ';
        switch (event.objectState) {
            case AlertRuleObjectState_1.AlertRuleObjectState.ADDED:
                desc += 'added';
                break;
            case AlertRuleObjectState_1.AlertRuleObjectState.DELETED:
                desc += 'deleted';
                break;
            case AlertRuleObjectState_1.AlertRuleObjectState.UPDATED:
                desc += 'updated';
                break;
        }
        desc += ` ${event.objectType} records `;
        switch (event.triggerType) {
            case AlertRuleTriggerType_1.AlertRuleTriggerType.AT_LEAST:
            case AlertRuleTriggerType_1.AlertRuleTriggerType.AT_MOST:
                desc += `was ${event.eventTriggerValue}.`;
                break;
            case AlertRuleTriggerType_1.AlertRuleTriggerType.DECREASE:
                desc += 'decreased';
                break;
            case AlertRuleTriggerType_1.AlertRuleTriggerType.INCREASE:
                desc += 'increased';
                break;
        }
        if (event.triggerType === AlertRuleTriggerType_1.AlertRuleTriggerType.DECREASE || event.triggerType === AlertRuleTriggerType_1.AlertRuleTriggerType.INCREASE) {
            // Even through we're storing Infinity in the original DTO, it cannot be represented in JSON so it comes across the
            // wire to the webapp as null.
            if (event.eventTriggerValue === Infinity || event.eventTriggerValue === null) {
                // The only time we can get a change value of Infinity is when the change is a percent and the old value is 0.
                desc += ` by more than ${event.ruleTriggerValue}%`;
            }
            else {
                desc += ` by ${event.eventTriggerValue}`;
                switch (event.triggerValueType) {
                    case AlertRuleTriggerValueType_1.AlertRuleTriggerValueType.COUNT:
                        break;
                    case AlertRuleTriggerValueType_1.AlertRuleTriggerValueType.PERCENT:
                        desc += '%';
                        break;
                }
            }
            desc += `, from ${event.oldCount} to ${event.newCount}.`;
        }
        return desc;
    }
    /**
     * Builds a new AlertEventInfo from a set of DAO properties.
     *
     * @param daoProps - the DAO properties
     */
    constructor(daoProps) {
        this.id = daoProps.id;
        this.orgId = daoProps.org_id;
        this.batchId = daoProps.batch_id;
        this.oldCount = daoProps.old_count;
        this.newCount = daoProps.new_count;
        this.recordType = daoProps.record_type;
        this.objectType = daoProps.object_type;
        this.objectState = daoProps.object_state;
        this.triggerType = daoProps.trigger_type;
        this.triggerValueType = daoProps.trigger_value_type;
        this.ruleTriggerValue = daoProps.rule_trigger_value;
        this.eventTriggerValue = daoProps.event_trigger_value;
        this.createdAt = daoProps.created_at;
        this.updatedAt = daoProps.updated_at;
        // Since we can't store Infinity in the db, look for our integer representation of Infinity and convert back.
        // The only time we can get a change value of Infinity is when the change is a percent and the old value is 0.
        if (this.eventTriggerValue === exports.MAX_CHANGE_VALUE &&
            this.oldCount === 0 &&
            this.triggerValueType === AlertRuleTriggerValueType_1.AlertRuleTriggerValueType.PERCENT) {
            this.eventTriggerValue = Infinity;
        }
    }
}
exports.AlertEventInfo = AlertEventInfo;
//# sourceMappingURL=AlertEventInfo.js.map